

function getPublicURL() {
  var host = window.location.hostname;
  let url="";

  if (host === "localhost") {
    url = "https://cliker.mx";
  }else{
    url = host
  }

  return url;
  //return "";
}

const env = {
    baseURL: "https://www.apiweb.cliker.mx",
    //baseURL: "http://apiweb.dv/", //192.168.130.93
    publicURL: getPublicURL(),
    shareFB: "https://www.facebook.com/sharer/sharer.php?u=",
    shareTW: "https://twitter.com/intent/tweet?text=",
    shareWA: "whatsapp://send?text=",
    shareIN: "https://www.linkedin.com/shareArticle?mini=true&url=",
    reCAPTCHA_site_key: "6Le82dQZAAAAAJ8aoCmHBzXq1L9qymXjsrta3rNN"
}

export default env;